/**
 * @generated SignedSource<<661dc382cc4a4b0435db4440e87d62b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ExperimentsGetExperimentsFlagHistoryQuery$variables = {
  userId: string;
};
export type ExperimentsGetExperimentsFlagHistoryQuery$data = {
  readonly userByPublicUserId: {
    readonly experimentsFlagHistories: ReadonlyArray<{
      readonly createdOn: any;
      readonly flagName: string | null | undefined;
      readonly id: string;
      readonly variantName: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ExperimentsGetExperimentsFlagHistoryQuery = {
  response: ExperimentsGetExperimentsFlagHistoryQuery$data;
  variables: ExperimentsGetExperimentsFlagHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "publicUserId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ExperimentsFlagHistoryNode",
  "kind": "LinkedField",
  "name": "experimentsFlagHistories",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flagName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "variantName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdOn",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExperimentsGetExperimentsFlagHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "userByPublicUserId",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExperimentsGetExperimentsFlagHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserNode",
        "kind": "LinkedField",
        "name": "userByPublicUserId",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c8946f16ce9ad88c67d0f3fe21b6e450",
    "id": null,
    "metadata": {},
    "name": "ExperimentsGetExperimentsFlagHistoryQuery",
    "operationKind": "query",
    "text": "query ExperimentsGetExperimentsFlagHistoryQuery(\n  $userId: String!\n) {\n  userByPublicUserId(publicUserId: $userId) {\n    experimentsFlagHistories {\n      id\n      flagName\n      variantName\n      createdOn\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3117ded83fb9175997c231621c5fd4e5";

export default node;
